import { setResourceMeta } from 'redux-resource';

const metaReducer =
  (resourceType) =>
  (state = {}, action, options) => {
    switch (action.type) {
      case 'READ_RESOURCES_SUCCEEDED':
      case 'READ_RESOURCES_FAILED':
      case 'UPDATE_RESOURCES_SUCCEEDED':
      case 'UPDATE_RESOURCES_FAILED':
        if (!action.meta) {
          return state;
        }
        if (action.resourceType !== resourceType) {
          return state;
        }
        const meta = setResourceMeta({
          resources: action.resources,
          meta: state.meta,
          newMeta: action.meta,
        });
        return {
          ...state,
          meta,
        };
      default:
        return state;
    }
  };

export default metaReducer;
